import { createFileRoute } from '@tanstack/react-router'
import { WeldmapHomePage } from 'pages/weldmap/WeldmapHomePage'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'

export const Route = createFileRoute('/weldmap/')({
  component: RouteComponent,
  staticData: {
    title: 'Weldmap',
  },
})

function RouteComponent() {
  const searchParams = Route.useSearch()

  return (
    <WeldmapHomePage
      orgId={searchParams[SEARCH_PARAM_ORG_ID]}
      siteId={searchParams[SEARCH_PARAM_SITE_ID]}
    />
  )
}
